import { useEffect, useRef, forwardRef } from 'react';
import { styled, IconButton as MaterialIconButton, IconButtonProps } from '@mui/material';
import { getDataIdGenerator } from '../../shared/utils/dataId';
import { Tooltip } from '../../tooltip/Tooltip';
import { TooltipMode } from '../../tooltip/interfaces';

export interface IconButtonExtendedProps extends IconButtonProps {
  dataId: string;
  label: string;
  tooltipMode?: TooltipMode;
}

// styling mui base icon button to match up HD styling
export const IconButton = styled(
  forwardRef<HTMLElement, IconButtonExtendedProps>(
    ({ dataId, label, tooltipMode, ...props }: IconButtonExtendedProps, ref) => {
      const iconButtonRef = useRef(null);

      useEffect(() => {
        if (!ref) {
          return;
        }

        if (typeof ref === 'function') {
          ref(iconButtonRef.current);
        } else {
          // eslint-disable-next-line no-param-reassign
          ref.current = iconButtonRef.current;
        }
      });

      const dataIdGenerator = getDataIdGenerator(dataId, 'icon-button');

      return (
        <Tooltip dataId='' title={label} mode={tooltipMode}>
          <MaterialIconButton {...props} data-id={dataIdGenerator('')} ref={iconButtonRef} />
        </Tooltip>
      );
    }
  )
)();
